import React from "react";
import { FiCheckCircle, FiXCircle } from "react-icons/fi";

const InclusionExclusion = ({ inclusions, exclusions }) => {
  // If data is coming as JSON string from backend
  const inclusionsList =
    typeof inclusions === "string" ? JSON.parse(inclusions) : inclusions;

  const exclusionsList =
    typeof exclusions === "string" ? JSON.parse(exclusions) : exclusions;

  return (
    <div className="Inclusion" id="Inclusions">
      <h2>Inclusion & Exclusion</h2>

      <div className="inclusion-exclusion">
        <div className="table-container">

          {/* Inclusion Table */}
          <div className="table inclusion-table">
            <div className="table-header inclusion-header">
              <div className="header-icon">
                <FiCheckCircle />
              </div>
              <h3>What's Included</h3>
            </div>

            <ul className="table-content inclusion-list">
              {inclusionsList.map((item, index) => (
                <li key={index}>
                  <span className="item-text">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Exclusion Table */}
          <div className="table exclusion-table">
            <div className="table-header exclusion-header">
              <div className="header-icon">
                <FiXCircle />
              </div>
              <h3>What's Not Included</h3>
            </div>

            <ul className="table-content exclusion-list">
              {exclusionsList.map((item, index) => (
                <li key={index}>
                  <span className="item-text">{item}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default InclusionExclusion;
